import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PlatformService } from '@core/services/platform.service';
import { SearchService } from '@core/services/search.service';
import { InspirationalSlider } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { ProductSearchViewModel } from '@models/api-search.models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImpressionTypePipe } from '@shared/tracking/pipes/impression-type.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { SafePipe } from '@shared/safe/safe.pipe';
import { ProductCardComponent } from '../../product/product-card/product-card.component';
import { ImpressionTrackingDirective } from '@shared/tracking/impression-tracking/impression-tracking.directive';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';
import { SliderComponent } from '../../slider/slider/slider.component';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { ArrowLinkComponent } from '@shared/arrow-link/arrow-link.component';
import { InterceptLinksDirective } from '@libs/routing/dynamic-routing/intercept-links.directive';
import { SpotHeadlineComponent } from '../spot-headline/spot-headline.component';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '@shared/image/image/image.component';
import { ParallaxElementDirective } from '../../parallax/parallax-element/parallax-element.directive';
import { NgIf, NgStyle, NgClass, NgFor } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-inspiration-slider',
    templateUrl: './inspiration-slider.component.html',
    styleUrls: ['./inspiration-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgStyle,
        ParallaxElementDirective,
        ImageComponent,
        RouterLink,
        SpotHeadlineComponent,
        InterceptLinksDirective,
        ArrowLinkComponent,
        NgClass,
        SvgIconComponent,
        SliderComponent,
        NgFor,
        LoadingDotsComponent,
        ImpressionTrackingDirective,
        ProductCardComponent,
        SafePipe,
        TranslateSafePipe,
        ImpressionTypePipe
    ]
})
export class InspirationSliderComponent implements OnInit {
    static ref = 'inspirationSlider';
    public fetchedProducts: ProductSearchViewModel[] | [] = [];
    public mainProduct: ProductSearchViewModel | undefined;

    @Input()
    public data: InspirationalSlider;

    @Input()
    public theme: string;

    constructor(
        private searchService: SearchService,
        private cd: ChangeDetectorRef,
        private platformService: PlatformService
    ) {}

    ngOnInit(): void {
        const { productSelectorList } = this.data;
        const productsToFetch = [...productSelectorList, ...(this.data.productId ? [this.data.productId] : [])];

        if (productsToFetch.length && this.platformService.isBrowser) {
            this.searchService
                .getProducts(...productsToFetch)
                .pipe(untilDestroyed(this))
                .subscribe(({ products = [] }) => {
                    // If productId was supplied, then remove that item from results, and save as mainProduct
                    if (this.data.productId && products.length) {
                        const index = products.findIndex(product => product.productNo === this.data.productId);
                        if (index !== -1) {
                            this.mainProduct = products.splice(index, 1)[0];
                        }
                    }
                    this.fetchedProducts = products;
                    this.cd.markForCheck();
                });
        }
    }
}
